import React from "react";

export default function Banner({ subtitle, title, desc, buttonText, buttonHref, onButtonClick, logoSrc }) {
    return (
        <section className="main-banner">
            <div className="main-banner__inner">
                <div className="main-banner__subtitle">{subtitle}</div>
                <div className="main-banner__title">{title}</div>
                <div className="main-banner__desc">{desc}</div>
                {buttonText && (
                    <div className="main-banner__button-wrap">
                        {buttonHref ? (
                            <a
                                href={buttonHref}
                                className="main-banner__button"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                {buttonText}
                            </a>
                        ) : (
                            <button className="main-banner__button" onClick={onButtonClick}>
                                {buttonText}
                            </button>
                        )}
                    </div>
                )}
                {logoSrc &&
                    <div className="main-banner__logo-wrap">
                        <img src={logoSrc} alt="Logo" className="main-banner__logo" />
                    </div>}
            </div>
        </section>
    );
}
